export default {
  home: "/",
  basic: "/basic",
  pro: "/pro",
  elite: "/elite",
};
